import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/img/astronaut-logo.png';
import navIcon1 from "../assets/img/nav-icon1.svg"
import navIcon2 from "../assets/img/github.svg"
import { Link } from 'react-bootstrap-icons';

export const NavBar = () => {  
    const [activeLink,setActiveLink] = useState('');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        }
        window.addEventListener("scroll",onScroll);

        return () => window.removeEventListener("scroll",onScroll);
    }, [])

    const onUpdateActiveLink = (value) => {
        setActiveLink(value);
    }
    
    return (
        <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
            <Container>
                <Navbar.Brand href="#home">
                    <img src={logo} alt="My Logo" onClick={() => onUpdateActiveLink('home')}/>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className='navbar-toggler-icon'></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link href="#home" className={activeLink === 'home' ? 'active-navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                    <Nav.Link href="#skills" className={activeLink === 'skills' ? 'active-navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
                    <Nav.Link href='#experiences&projects' className={activeLink === 'experiences&projects' ? 'active-navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('experiences&projects')}>Experiences & Projects</Nav.Link>
                </Nav>
                <span className='navbar-text'>
                    <div className='social-icon'>
                        <a href='https://www.linkedin.com/in/khangnguyen23/' target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="LinkedIn"/></a>
                        <a href='https://github.com/DuyKhangTruong' target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="Github"/></a>
                    </div>
                    {/* <button className='vvd' onClick={(e) => {e.preventDefault(); window.location.replace('/#connect');
                onUpdateActiveLink("connect")}}><span>Let's connect</span></button> */}
                    {/* <button className='vvd'><span>Let's connect</span></button> */}
                </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}